import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { platform, type Platform } from '../platform/detect'
import { session as store } from '../api/client'

type State = {
  /** Where the game runs; decides the way to sign in. */
  platform: Platform
  /** A refresh token is kept (the access token is renewed on demand). */
  signedIn: boolean
}

export const session = createSlice({
  name: 'session',
  // Every VK document must first verify its current launch, even with a saved token.
  initialState: (): State => ({ platform: platform(), signedIn: platform() !== 'vk' && Boolean(store.refreshToken) }),
  reducers: {
    signedIn: (s, a: PayloadAction<boolean>) => {
      s.signedIn = a.payload
    },
  },
})
